export const PROFESSIONAL_PROFILE_AUTOSAVE_KEY = 'professional_profile';

export const MODALITY_OPTIONS = [
    { value: "presential", label: "Presencial", labelEn: "In-person" },
    { value: "virtual", label: "Virtual", labelEn: "Online" },
    { value: "hybrid", label: "Presencial/Virtual", labelEn: "In-person/Online" }
];

export const PREFIX_OPTIONS = [
    "T.", 
    "Facilitador.", 
    "Facilitadora.", 
    "Prof.", 
    "Prof.a", 
    "Ing.", 
    "Lic.", 
    "Dr.", 
    "Dra.", 
    "Mtro.", 
    "Mtra."
];
